// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ManualCard_wrapper__3tgFV","info":"ManualCard_info__2Ykf2","title":"ManualCard_title__1UQFp","text":"ManualCard_text__tPmaJ","image":"ManualCard_image__3RUCD"};